// extracted by mini-css-extract-plugin
export default {"container":"LoaderGlobal_container__0jCuE"};